export const getParamName = (param: string, params: { [key: string]: {name: string} }) => {
  return params.hasOwnProperty(param) ? params[param].name : null
}